import React from 'react'
import { Text, Container, Heading, Input } from '@chakra-ui/react'

import { FormField, FieldList, FieldListItem, WizardStepForm } from 'components'

import { useAuthQuery } from 'modules/auth'
import { UserExperienceDataSelect } from 'modules/users'

export const UserRegistrationStep2 = props => {
  const { data, loading } = useAuthQuery()

  return (
    <WizardStepForm {...props} justify='center'>
      <Heading size='2xl' textAlign='center' my={5}>
        Dados do Utilizador
      </Heading>
      <Container my={5}>
        <Text textAlign='end'  color='red.500'>* Resposta obrigatória</Text>
        <FieldList my={3} variant='vertical' isLoading={loading}>
          <FieldListItem label='Nome'>
            <Input type='text' isReadOnly value={data?.name} />
          </FieldListItem>

          <FieldListItem isRequired label='Experiência em IA'>
            <FormField name='user.experience.id'>
              <UserExperienceDataSelect />
            </FormField>
          </FieldListItem>
        </FieldList>
      </Container>
    </WizardStepForm>
  )
}

export default UserRegistrationStep2
